import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Full from './views/Full.vue'
import About from './views/About.vue'
import Contato from './views/Contato.vue'
import Produtos from './views/Produtos.vue'
import ServicoDetalhe from './views/DetalhesServico.vue'
import ProdutosDetalhe from './views/DetalhesProduto.vue'
import Servicos from './views/Servicos.vue'
import Login from './views/Login.vue'
import FullAdm from './views/FullAdm'
import ProdutosAdm from './views/ProdutosAdm'
import ServicosAdm from './views/ServicosAdm'
import CategoriasProdAdm from './views/CategoriasProdAdm';
import CategoriasServAdm from './views/CategoriasServAdm';
import NovaCategoria from './views/NovaCategoria';
import NovoProduto from './views/NovoProduto';
import NovoServico from './views/NovoServico';
import HomeAdm from './views/HomeAdm'

import firebase from 'firebase'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      component: Login,
      name: 'Login',
      meta: {requiresAuth: false}
    },
    {
      path: '/',
      component: Full,
      children: [
        {
          path: 'home',
          alias: '',
          component: Home,
          name: 'PaginaInicial',
          meta: {requiresAuth: false}
        },
        {
          path: 'sobre',
          alias: '',
          component: About,
          name: 'Sobre',
          meta: {requiresAuth: false}
        },
        {
          path: 'contato',
          alias: '',
          component: Contato,
          name: 'Contato',
          meta: {requiresAuth: false}
        },
        {
          path: 'servicos',
          alias: '',
          component: Servicos,
          name: 'Servicos',
          meta: {requiresAuth: false}
        },
        {
          path: 'produtos',
          alias: '',
          component: Produtos,
          name: 'Produtos',
          meta: {requiresAuth: false}
        },
        {
          path: 'produtos/:categoria',
          alias: '',
          component: Produtos,
          name: 'Produtos',
          meta: {requiresAuth: false}
        },
        {
          path: 'servicos/detalhe/:id',
          alias: '',
          component: ServicoDetalhe,
          name: 'DetalhesServico',
          meta: {requiresAuth: false}
        },
        {
          path: 'produtos/detalhe/:id',
          alias: '',
          component: ProdutosDetalhe,
          name: 'DetalhesProduto',
          meta: {requiresAuth: false}
        }
      ]
    },
    {
      path: '/admin',
      component: FullAdm,
      children: [
        {
          path: 'homeAdmin',
          alias: '',
          component: HomeAdm,
          name: 'Pagina Administrativa',
          meta: {requiresAuth: true}
        },
        {
          path: 'produtos',
          alias: '',
          component: ProdutosAdm,
          name: 'Produtos Admin',
          meta: {requiresAuth: true}
        },
        {
          path: 'servicos',
          alias: '',
          component: ServicosAdm,
          name: 'Servicos Admin',
          meta: {requiresAuth: true}
        },
        {
          path: 'categorias-servicos',
          alias: '',
          component: CategoriasServAdm,
          name: 'Categorias Serv Admin',
          meta: {requiresAuth: true}
        },
        {
          path: 'categorias-produtos',
          alias: '',
          component: CategoriasProdAdm,
          name: 'Categorias Prod Admin',
          meta: {requiresAuth: true}
        },
        {
          path: 'nova-categoria',
          alias: '',
          component: NovaCategoria,
          name: 'Nova Categoria',
          meta: {requiresAuth: true}
        },
        {
          path: 'novo-servico',
          alias: '',
          component: NovoServico,
          name: 'Novo Servico',
          meta: {requiresAuth: true}
        },
        {
          path: 'novo-produto',
          alias: '',
          component: NovoProduto,
          name: 'Novo Produto',
          meta: {requiresAuth: true}
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(function (user) {
    // var user = firebase.auth().currentUser;
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (user != null) {
      next()
    } else if (!requiresAuth) {
      next()
    } else next('login')
  })
})

export default router
